import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { listConversations } from "@/lib/chat";
import { useAuth } from "@/context/AuthContext";

export const MessagesIcon = () => {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!user) return setCount(0);
    const load = () => listConversations().then((cs) => setCount(cs.filter((c) => c.unread).length)).catch(() => {});
    load();
    const t = setInterval(load, 20000);
    window.addEventListener("lamka:chat-read", load);
    return () => { clearInterval(t); window.removeEventListener("lamka:chat-read", load); };
  }, [user, pathname]);

  return (
    <Link to="/messages" data-testid="nav-messages-button" aria-label="Messages" className="relative p-2 min-[350px]:p-2.5 text-white/80 hover:text-[#C5A059] transition-colors">
      <MessageCircle className="h-5 w-5" strokeWidth={1.5} />
      {count > 0 && (
        <span data-testid="messages-unread-badge" className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-[#C5A059] text-[#0F0F0F] text-[10px] font-mono font-bold flex items-center justify-center">
          {count > 99 ? "99+" : count}
        </span>
      )}
    </Link>
  );
};
